import moment from "moment";

export class ExportPeriod {

    public readonly code!: string;
    public readonly label!: string;
    public readonly dateFrom!: moment.Moment;
    public readonly dateTo!: moment.Moment;

    static getPeriods(): ExportPeriod[] {
        let periods: ExportPeriod[] = [];

        const today = moment();
        const currentQuarter = Math.floor((today.month() + 3) / 3);
        const previousQuarter = Math.floor((today.month() + 3) / 3) - 1;
        const beginingOfTimes = moment('0000-01-01');
        const endOfTimes = moment('9999-12-31');

        // Tout
        periods.push(new ExportPeriod('all', 'Tout', beginingOfTimes, endOfTimes));
        // Aujourd'hui
        periods.push(new ExportPeriod('today', 'Aujourd\'hui', today, today));
        // Ce mois
        periods.push(new ExportPeriod('month', 'Ce mois', today.clone().startOf('month'), today.clone().endOf('month')));
        // Ce trimestre
        periods.push(new ExportPeriod('quarter', 'Ce trimestre', today.clone().quarter(currentQuarter).startOf('quarter'), today.clone().quarter(currentQuarter).endOf('quarter')));
        // Cette année
        periods.push(new ExportPeriod('year', 'Cette année', today.clone().startOf('year'), today.clone().endOf('year')));
        // Année à ce jour
        periods.push(new ExportPeriod('yearToToday', 'Année à ce jour', today.clone().startOf('year'), today));
        // Hier
        periods.push(new ExportPeriod('yesterday', 'Hier', today.clone().subtract(1, 'day'), today.clone().subtract(1, 'day')));
        // Cette semaine
        periods.push(new ExportPeriod('week', 'Cette semaine', today.clone().startOf('week'), today.clone().endOf('week')));
        // Mois précédent
        periods.push(new ExportPeriod('pastMonth', 'Mois précédent', today.clone().subtract(1, 'month').startOf('month'), today.clone().subtract(1, 'month').endOf('month')));
        // Trimestre précédent
        periods.push(new ExportPeriod('pastQuarter', 'Trimestre précédent', today.clone().quarter(previousQuarter).startOf('quarter'), today.clone().quarter(previousQuarter).endOf('quarter')));
        // Année précédente
        periods.push(new ExportPeriod('pastYear', 'Année précédente', today.clone().subtract(1, 'year').startOf('year'), today.clone().subtract(1, 'year').endOf('year')));
        // Semaine précédente
        periods.push(new ExportPeriod('pastWeek', 'Semaine précédente', today.clone().subtract(1, 'week').startOf('week'), today.clone().subtract(1, 'week').endOf('week')));
        // Année glissante (12 derniers mois)
        periods.push(new ExportPeriod('rollingYear', 'Année glissante', today.clone().subtract(12, 'months'), today));
        // Personnaliser
        // periods.push(new ExportPeriod('custom', 'Personnaliser', today, today));

        return periods;
    }

    constructor(code: string, label: string, from: moment.Moment, to: moment.Moment) {
        this.code = code;
        this.label = label;
        this.dateFrom = from;
        this.dateTo = to;
    }

}